<template>
  <div class="ql-editor main" v-loading="loading" :class="{ loadingHeight: loading }">
    <div style="width: 100%;">
      <div v-html="content"></div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      content: '',
      id: ''
    }
  },

  mounted() {
    this.loading = true
    this.id = this.$route.params.id
    this.Api.NavigationContentSearchApi({
      "userId": "",
      "userName": "",
      "id": this.id
    })
      .then(res => {
        this.loading = false
        if (res.Code == 200) {
          this.content = res.Data[0].content
        }
      })
  }
}

</script>

<style  scoped>
.main {
  display: flex;
  justify-content: center;
  padding: 20px;
  min-height: 500px;
}

.loadingHeight {
  height: 1000px;
}

.main {
  width: 80%;
  margin: 0 auto;
}
</style>